"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _KeyStore = require("crm_data/store/KeyStore");

var _ObjectTypes = _interopRequireDefault(require("customer-data-objects/constants/ObjectTypes"));

var _ActionTypes = require("crm_data/actions/ActionTypes");

var _default = (0, _KeyStore.defineKeyStore)({
  namespace: 'TIMELINE_FAVORITE_EVENTS_OVERRIDE',
  idIsValid: function idIsValid(objectType) {
    return Object.prototype.hasOwnProperty.call(_ObjectTypes.default, objectType);
  }
}).defineResponseTo(_ActionTypes.SET_FAVORITE_EVENT_OVERRIDE, function (state, _ref) {
  var objectType = _ref.objectType,
      eventTypes = _ref.eventTypes;
  return state.set(objectType, (0, _immutable.Map)({
    isLoading: true,
    eventTypes: eventTypes
  }));
}).defineResponseTo(_ActionTypes.FETCH_TIMELINE_ITEMS_SUCCESS, function (state, data) {
  var objectType = data.getIn(['originalPayload', 'objectType']);

  if (state.get(objectType)) {
    return state.setIn([objectType, 'isLoading'], false);
  }

  return state;
}).defineResponseTo(_ActionTypes.CLEAR_FAVORITE_EVENT_OVERRIDE, function (state, _ref2) {
  var objectType = _ref2.objectType;
  return state.delete(objectType);
}).defineResponseTo(_ActionTypes.NAVIGATE, function (state) {
  return state.clear();
}).register();

exports.default = _default;
module.exports = exports.default;